import React from 'react';
import { View, StyleProp, ViewStyle, ReturnKeyTypeOptions } from 'react-native';
import { TextInput, Text, useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';

interface NifInputProps {
  label?: string;
  value: string;
  onChange: (text: string) => void;
  onBlur?: () => void;
  style?: StyleProp<ViewStyle>;
  errorText?: string;
  testID?: string;
  onSubmitEditing?: () => void;
  returnKeyType?: ReturnKeyTypeOptions;
}

const removeMask = (value: string): string => value.replace(/\D/g, '');

const applyMaskNif = (value: string): string =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d{3})(\d{3})/, '$1.$2.$3')
    .substring(0, 11);

export const NifInput: React.FC<NifInputProps> = ({
  label,
  value,
  onChange,
  onBlur,
  style,
  errorText,
  testID,
  onSubmitEditing,
  returnKeyType,
}) => {
  const theme = useTheme();
  const { t } = useTranslation('register');

  const digits = removeMask(value);
  const isInvalid = !!errorText || (!!value && digits.length !== 9);

  return (
    <View style={style}>
      <TextInput
        mode="outlined"
        label={label || t('nifPlaceholder')}
        keyboardType="numeric"
        value={value}
        onChangeText={(text) => onChange(applyMaskNif(text))}
        onBlur={onBlur}
        error={isInvalid}
        style={{ marginBottom: 4 }}
        testID={testID}
        onSubmitEditing={onSubmitEditing}
        returnKeyType={returnKeyType}
      />
      {isInvalid && (
        <Text style={{ color: theme.colors.error, fontSize: 12 }}>
          {errorText || t('nifInvalidLength')}
        </Text>
      )}
    </View>
  );
};

export default NifInput;


